import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export function useColleagues(userId: string) {
  const { api } = useTacticHooks();
  const {
    data: colleagues,
    error,
    isFetching
  } = useQuery({
    queryKey: ['organizations.user.colleagues', userId],

    queryFn: async () => {
      const res = await api.client.organizations.userColleagues(userId);
      return res.result;
    }
  });
  return { colleagues, error, isFetching };
}
